import { DataDisplayEvent, DataSourceMode, Label, Tab } from "@mcleod/components";
import { AutogenLayoutEdiOrderCarrierPay } from "./autogen/AutogenLayoutEdiOrderCarrierPay";

export class EdiOrderCarrierPay extends AutogenLayoutEdiOrderCarrierPay {

    override onLoad(): void | Promise<void> {
        this.styleTab(this.tabPayAdjustments);
    }

    sourceViewEdiOrderAfterModeChange(){
        if((this.mainDataSource.mode == DataSourceMode.SEARCH)){
            this.textboxOverridePayAmt.printable = false;
            this.textboxOverridePayAmt.printableDuringSearch = false;
            this.textboxOverridePayAmt.marginTop = 0;
            this.textboxPayAdjustmentTotal.printable = false;
            this.textboxPayAdjustmentTotal.printableDuringSearch = false;
            this.textboxTotalPay.printable = false;
            this.textboxTotalPay.printableDuringSearch = false;
         }
    }

    sourceExtraPayAfterExecution() {
        this.tabPayAdjustments["countLabel"].text = this.sourceEdiDriverextrapay.data.length;
    }

    /** This is an event handler for the onDataDisplay event of textboxOverridePayRate.  */
    textboxOverridePayRateOnDataDisplay(event: DataDisplayEvent) {
        const miles = this.mainDataSource.activeRow?.get("bill_distance");
        const pay = this.mainDataSource.activeRow?.get("override_pay_amt");

        if (miles != null) {
            this.labelBillDistance.text = miles + " miles";
        } else {
            this.labelBillDistance.text = "";
        }

        if (miles != null && pay != null) {
            const payPerMile: number = pay.base_amount / miles;
            this.labelRateDesc.text = payPerMile.toFixed(2) + "/mile";
        } else {
            this.labelRateDesc.text = "";
        }
    }

    styleTab(tab: Tab) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = "subtle.light";
            tab.headingLabel.setProps({ color: "default", fontBold: true, fillRow: false })
            if (tab["countLabel"] == null) {
                tab["countLabel"] = new Label({
                    fontBold: true, text: "0", fillRow: true,
                    color: "primary", rowBreak: false, marginLeft: 5
                });
                tab.heading.insert(tab["countLabel"], 1);
            }
        }
    }

}
